import { createContext, useReducer } from 'react'
import { AlertReducer } from '@/helpers/utility/alerts/alert_reducer'
import { AlertTypes } from '@/helpers/constant/enum_data'

const initialState = {
  alertShower: {
    type: AlertTypes.NONE,
    message: '',
    action: '',
  },
  modalShower: {
    heading: '',
    message: '',
    action: ''
  }
}

export const AlertContext = createContext(initialState)

export const AlertProvider = ({ children }) => {
  const [state, dispatch] = useReducer(AlertReducer, initialState)
  const value = [state, dispatch]
  return <AlertContext.Provider value={value}>{children}</AlertContext.Provider>
}
